import React, { useEffect, useState } from 'react';
import axios from '../../../utils/axiosExt';
import UserPage1 from './UserPage1';
import UserPage2 from './UserPage2';
import UserPage3 from './UserPage3';
import Loading from "@components/common/Loading";
import './CreateNewUser.css';
import { useDispatch,useSelector } from 'react-redux';
import { resetForm, updateForm } from '../../../store/actions/userManagementAction';
import { RootState } from '../../../store/reducers';
import { getData,getDataParams, getDataWithCache, postDataJSON } from '../../../services/CommonApiService';
import endpoints from '../../../config/endpoints';
import { useNavigate } from 'react-router-dom';
import RedInfoIcon from '../../../assets/svg/exclamation.svg'
import ButtonModal from '@components/common/Button';
import CreateCommonComponent from '@components/common/CreateComponent';
import Auth from "../../../utils/auth";

import { toast } from 'react-toastify';
import { errorLogger, infoLogger } from '@utils/applicationLogUtils';
import {  decodeWithKeyAndShift, encodeWithKeyAndShift } from '../../../utils/base64Utils';
import CommonModal from '../CreateNewUser/AlertModal/index';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import { userDesignationConstant } from '@constants/appConstants';
import {
  CREATOR_GROUPS,
  OFFLINE_ENABLED_DESIGNATIONS,
  RURAL_URBAN,
  RURAL_URBAN_OPTION_IDS,
  USER_TYPE,
} from './constant';
import {
  applyFieldPatches,
  applyFieldRuleGroups,
  applyFieldOptions,
  findMatchedOption,
  getSelectedOptionsMeta,
  mapBlockOptions,
  mapDistrictOptions,
  mapGramPanchayatOptions,
  mapHealthBlockOptions,
  mapOptions,
  mapRuralUrbanOptions,
  mapStateOptions,
  mapSubDistrictOptions,
  mapSubDivisionOptions,
  mapUlbOptions,
  mapVillageOptions,
  mapWardOptions,
  mapZoneDivisionOptions,
  resetFieldsState,
  setIsFieldDisabledOrRequired,
  shouldLockLoggedInHierarchyField,
} from './utility';
import {
  applyFacilityNameOptions,
  getFacilityTypeNameById,
  getFacilityTypeSelectionPatch,
  getFacilityTypeValueById,
  getHealthFacilityNameSelectionPatch,
  getHfrStatePatch,
  getHfrVerifyPatch,
  getSelectedFacilityMeta,
  getSingleFacilityNameOptions,
  mapFacilityOptions,
  mapFacilityTypeOptions,
  mapTaggedUserOptions,
} from './facilityController';
import {
  getMfaFieldConfig,
  getOfflineAccessFieldConfig,
} from './userRulesController';
import {
  useDebouncedCallback,
  useFacilityLocationEffects,
  useHierarchyCascadeEffects,
  useTaggedProviderEffects,
  useUserTypeMeta,
} from './customhooks';
import {
  validateBasicDetailsStep,
  validateFacilityDetailsStep,
  validateRoleHierarchyStep,
} from './validationUtils';
import { buildCreateUserPayload } from './payloadBuilder';
import { useCreateNewUserFormState } from './formStateController';
import { useUserDetailsForm } from './useUserDetailsForm';
interface newUserProps {
    page?: string;
    flow?: string;
}

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?:any,
  code?:any,
  compositeRoleId?:any,
}

export interface formStateType {
  [key: string]: objectType
}

enum LocationType {
  Village = 'village',
  Ward = 'ward',
  GP = 'gp'
}
enum UserDesignation{
  anm='ANM',
}

const CreateNewUser: React.FC<newUserProps> = ({ page }: any) => {
  //Modal Pages
  const [verifyHfr] = useState<boolean>(false);
  const [verifyAbha] = useState<boolean>(false);
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
  const [initialFacilityNames, setInitialFacilityNames]=useState<any>({});
  const [intialFacilityTypes, setIntialFacilityTypes]=useState<any>({});
  const isOkButtonClicked=useSelector((state:RootState)=>state.user.isOkButtonClicked);
  const hprNullCheck=useSelector((state:RootState)=>state.user.hprNullCheck);
  const hprNumberCheck=useSelector((state:RootState)=>state.user.hprNumberCheck);
  const dispatch=useDispatch();
  const Files=useSelector((state:RootState)=>state.user.file);
  const ishprEntered=useSelector((state:RootState)=>state.user.ishprEntered);
  const clearHpr=useSelector((state:RootState)=>state.user.clearHpr);
  const isNotVerified=useSelector((state:RootState)=>state.user.isNotVerified);
  const isVerified=useSelector((state:RootState)=>state.user.isVerified);
  const hfrAbhaId=useSelector((state:RootState)=>state.user.hfrAbha);
  const faceAuthVerifiedMob=useSelector((state:RootState)=>state.user.mob);
  const [hasZonesCreated, setHasZonesCreated] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false);  
  const [userTypeName] = useState<any>(localStorage.getItem('userTypeName'));
  const canEditZoneDivCircle = [USER_TYPE.NATIONAL_LEVEL, USER_TYPE.STATE_LEVEL].includes(userTypeName);
  const [isGrampanchayat, setIsGrampanchayat] = useState<boolean>(false);  
  const isBlockLevelLogin = userTypeName === 'Block Level User';
  const [hasBlocksForDistrict, setHasBlocksForDistrict] = useState<boolean | null>(null);
  const [facilityLocationId, setFacilityLocationId] = useState<string>('');  
  const [facilityLocationType, setFacilityLocationType] = useState<LocationType>();  
  const [ulbInputText, setUlbInputText] = useState<string>('');
  const consentDetails = useSelector((state:RootState)=>state.user.consentDetails)
  const verificationProcessId = useSelector((state:RootState)=>state.user.verificationProcessId)
  const LoggedInUserId = localStorage.getItem('userId');
  const userDetails = localStorage.getItem('userDetails');
  const loggedInUserDetails=JSON.parse(decodeWithKeyAndShift(userDetails));

  const checkIfUsingGramPanchayat =async () =>{
    if(roleFormState?.state?.code){
      try {
        let isUsingGramPanchayat: boolean = false;
        isUsingGramPanchayat = await isUsingGramPanchayatUtils(roleFormState?.state?.code);
        setIsGrampanchayat(isUsingGramPanchayat);
        setRoleFormData((role_details:any) => ({
          ...role_details,
          village:{
            ...role_details?.village,
            '#isVisible': isUsingGramPanchayat ? false : true,      
          },
          gram_panchayat:{
            ...role_details?.gram_panchayat,
            '#isVisible': isUsingGramPanchayat ? true : false, 
          }
        }));
        setfacilityFormData((facilityFormData:any)=>({
          ...facilityFormData,
          village:{
            ...facilityFormData.village,
            '#isVisible': isUsingGramPanchayat ? false : true,      
          },
          gram_panchayat:{
            ...facilityFormData.gram_panchayat,
            '#isVisible': isUsingGramPanchayat ? true : false, 
          }
        }));
        setfieldFormData((facilityFormData:any)=>({
          ...facilityFormData,
          village:{
            ...facilityFormData.village,
            '#isVisible': isUsingGramPanchayat ? false : true,      
          },
          gram_panchayat:{
            ...facilityFormData.gram_panchayat,
            '#isVisible': isUsingGramPanchayat ? true : false, 
          }
        }));

      }     catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
     }
    }
  }

  const {
    formState1,
    setFormState1,
    roleFormState,
    setRoleFormState,
    userData,
    setUserData,
    ruralUrban,
    setRuralUrban,
    ruralUrbanId,
    setRuralUrbanId,
    formStateForFacility,
    setFormStateForFacility,
    formStateForField,
    setFormStateForField,
    roleFormData,
    setRoleFormData,
    facilityFormData,
    setfacilityFormData,
    fieldFormData,
    setfieldFormData,
    hfrVerifyFormData,
    setHfrVerifyFormData,
  }: any = useCreateNewUserFormState();
  const isLoggedInHierarchyFieldLocked = (fieldName: string) => (
    shouldLockLoggedInHierarchyField(userTypeName, fieldName, loggedInUserDetails)
  );
  const shouldDisableZoneDivCircleForCreatedUser = [USER_TYPE.NATIONAL_LEVEL, USER_TYPE.STATE_LEVEL].includes(formState1?.user_type?.value);
  const { isFacilityLevelUser, isFieldLevelUser, navItemsModal } = useUserTypeMeta(formState1.user_type.value);
  const isSubDistrictUserType = (value?: string) => {
    const normalized = (value || '').trim().toLowerCase();
    return (
      normalized === USER_TYPE.SUB_DISTRICT_LEVEL.toLowerCase() ||
      normalized === 'sub district level user' ||
      normalized === 'sub-district/taluka level user' ||
      normalized.includes('sub district') ||
      normalized.includes('taluka')
    );
  };

// new window code - create new user
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [isFormValidated, setIsFormValidated] = useState<boolean>(false);
  const [formCompleted, setFormCompleted] = useState<boolean[]>(
    Array(navItemsModal.length).fill(false),
  );
  const [closeModal,setCloseModal]=useState<boolean>(false)

  const [selectPerc, setSelectedPerc] = useState<any>(0);
  const navs = 100 / navItemsModal.length;
  const [errors, setErrors] = useState<boolean[]>([]);
  const { handleFormChange1 } = useUserDetailsForm({
    dispatch,
    navItemsModal,
    setFormCompleted,
    formState1,
    setFormState1,
    setUserData,
    setfacilityFormData,
    setfieldFormData,
    clearHpr,
    isVerified,
    hfrAbhaId,
    faceAuthVerifiedMob,
    setAlertModalOpen,
  });
  //userPage2

  const handleFormChange2 = (value: string | boolean, key: string,option?:any,id?:any,code?:any, compositeRoleId?:any) => {
    setFormCompleted([true,false]);
    if(key==='rural_urban') {
      setRuralUrban(value) ;
      setRuralUrbanId(id);
    }
        setRoleFormState((prevState: any) => ({
          ...prevState,
          [key]: {
            ...prevState[key],
            value: value,
            isError: false,
            message: '',
            id:id,
            code:code,
            compositeRoleId:compositeRoleId,
          },
        }));
      setFormStateForFacility((facilityState:any)=>applyFieldPatches(facilityState, {
        hfr_id:{ value:'' },
        health_facility_type:{ value:'', id:'' },
        health_facility_name:{ value:'', id:'' },
        health_provider_tagged:{ value:'', id:[] },
        mobiliser_tagged:{ value:'', id:[] },
        ward:{ value:'', id:[], code:[] },
        village:{ value:'', id:[], code:[] },
        gram_panchayat:{ value:'', id:[], code:[] },
        volunteerForPmsma:{ value:false },
      }));
    setFormStateForField((facilityState:any)=>applyFieldPatches(facilityState, {
      hfr_id:{ value:'' },
      health_facility_type:{ value:'', id:'' },
      health_facility_name:{ value:'', id:'' },
      health_provider_tagged:{ value:'', id:[] },
      mobiliser_tagged:{ value:'', id:[] },
      ward:{ value:'', id:[], code:[] },
      village:{ value:'', id:[], code:[] },
      gram_panchayat:{ value:'', id:[], code:[] },
  }))
  };


  //userPage3
  const setFacilityByFacilityType = async (type_id:string, value:any) =>{
    const updatedOptions= initialFacilityNames?.facilityOptions?.filter((option:any)=>option.fac_type_id  === type_id);
    setfacilityFormData((facilityFormData:any)=>applyFieldOptions(facilityFormData, 'health_facility_name', updatedOptions));
    setfieldFormData((facilityFormData:any)=>applyFieldOptions(facilityFormData, 'health_facility_name', updatedOptions));
    if(value === undefined || value === '')
    {
      setfacilityFormData((facilityFormData:any)=>applyFieldOptions(facilityFormData, 'health_facility_name', initialFacilityNames.facilityOptions));
      setfieldFormData((facilityFormData:any)=>applyFieldOptions(facilityFormData, 'health_facility_name', initialFacilityNames.facilityOptions));
    }
  }

  const setFacilityByFacilityName = async (type_id:string) =>{
    const selectedFacilitytype = getFacilityTypeValueById(intialFacilityTypes?.facilityTypeOptions, type_id);
    const facilityTypePatch = getFacilityTypeSelectionPatch(selectedFacilitytype);
    setFormStateForFacility((facilityState:any)=>applyFieldPatches(facilityState, facilityTypePatch));
    setFormStateForField((facilityState:any)=>applyFieldPatches(facilityState, facilityTypePatch))
  }

  const setHFRValue = async (hfrID:string, value:any)=>{
    const hfrStatePatch = getHfrStatePatch(hfrID);
    setFormStateForFacility((facilityState:any)=>applyFieldPatches(facilityState, hfrStatePatch));
    setFormStateForField((facilityState:any)=>applyFieldPatches(facilityState, hfrStatePatch));
    setHfrVerifyFormData((hfrVerifyFormData:any) => applyFieldPatches(hfrVerifyFormData, getHfrVerifyPatch(hfrID)))
    if(value === undefined || value === '')
      {
        setFormStateForFacility((facilityState:any)=>applyFieldPatches(facilityState, getHfrStatePatch('')));
        setFormStateForField((facilityState:any)=>applyFieldPatches(facilityState, getHfrStatePatch('')));
    }

  }

  const handleFormChange3 = (value: string | boolean, key: string,id?:any,option?:any,code?:any) => {
    setFormCompleted([true,true,false]);
    if(formState1.user_type.value==='Facility Level User'){
      setFormStateForFacility((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id:id,
          isError: false,
            message: '',
            code:code
        },
      }));
    }
    else{
      setFormStateForField((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id:id,
          code:code,
          isError: false,
          message: '',

        },
      }));
    }
    if(key === 'health_facility_type'){
      setFacilityByFacilityType(id, value);
      setFormStateForFacility((facilityState:any)=>applyFieldPatches(facilityState, {
        health_facility_name:{ value:'' },
        hfr_id:{ value:'' },
        mobiliser_tagged:{ value:[] },
      }));
      setFormStateForField((facilityState:any)=>applyFieldPatches(facilityState, {
        health_facility_name:{ value:'' },
        hfr_id:{ value:'' },
        health_provider_tagged:{ value:[], id: [] },
      }));
      setHfrVerifyFormData((hfrVerifyFormData:any) => ({
      hfrId:{
        ...hfrVerifyFormData.hfrId,
        '#isDisabled':false,
      }
    }))
    }
    if(key === 'health_facility_name'){
      const { facilityTypeId: facilityID, hfrId: hfrID } = getSelectedFacilityMeta(option, id);
      setFacilityByFacilityName(facilityID);
      setHFRValue(hfrID, value);
      setFormStateForFacility((facilityState:any)=>applyFieldPatches(facilityState, {
        mobiliser_tagged:{ value:[] },
        village:{ value:[], id:[], code:[] },
        gram_panchayat:{ value:[], id:[], code:[] },
        ward:{ value:[], id:[], code:[] },
      }));
      setFormStateForField((facilityState:any)=>applyFieldPatches(facilityState, {
        health_provider_tagged:{ value:[], id: [] },
        village:{ value:[], id: [], code:[] },
        gram_panchayat:{ value:[], id: [], code:[] },
        ward:{ value:[], id: [], code:[] },
      }));
    }
    if(key === 'hfr_id'){
      if(value === ''){
        setFacilityByFacilityType('', '');
        setFormStateForFacility((facilityState:any)=>applyFieldPatches(facilityState, {
          health_facility_type:{ value:'', id:'' },
        }));
        setFormStateForField((facilityState:any)=>applyFieldPatches(facilityState, {
          health_facility_type:{ value:'', id:'' },
        }));
      }
      let facilityNameOptions:any= [];
      if(option){
        facilityNameOptions = getSingleFacilityNameOptions(option);
        setfacilityFormData((facilityFormData:any) => applyFieldOptions(facilityFormData, 'health_facility_name', facilityNameOptions));
        setfieldFormData((facilityFormData:any) => applyFieldOptions(facilityFormData, 'health_facility_name', facilityNameOptions));
      }
      const facilityNamePatch = getHealthFacilityNameSelectionPatch(option);
      setFormStateForFacility((facilityState:any)=>applyFieldPatches(facilityState, facilityNamePatch));
      setFormStateForField((facilityState:any)=>applyFieldPatches(facilityState, facilityNamePatch));
    }
    }

  const getHealthProviderTagged=async(facility_id:any) =>{
    try {
      const response = await axios.get(`${endpoints.getHealthProviderTagged(facility_id)}`, Auth.loggedIn());
      const taggedHP = response?.data?.data;
      const taggedHPOptions = response.status === 200 && taggedHP.length > 0 ? mapTaggedUserOptions(taggedHP) : [];
      setfieldFormData((facilityFormData:any) => applyFieldOptions(facilityFormData, 'health_provider_tagged', taggedHPOptions))
    }     catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  const getASHAMobiliserTagged=async(facility_id:any) =>{
    try {
      const response = await axios.get(`${endpoints.getASHAMobiliserTagged(facility_id)}`, Auth.loggedIn());
      const taggedASHA = response?.data?.data;
      const taggedASHAOptions = response.status === 200 && taggedASHA.length > 0 ? mapTaggedUserOptions(taggedASHA) : [];
      setfacilityFormData((facilityFormData:any) => applyFieldOptions(facilityFormData, 'mobiliser_tagged', taggedASHAOptions))
    }     catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  useTaggedProviderEffects({
    isFacilityLevelUser,
    isFieldLevelUser,
    facilityId: formStateForFacility?.health_facility_name?.id,
    fieldFacilityId: formStateForField?.health_facility_name?.id,
    getASHAMobiliserTagged,
    getHealthProviderTagged,
  })

  //Get UserTypes
  useEffect(()=>{
    const userTypeId = localStorage.getItem('userTypeId');
    getUserType(userTypeId);
    checkIfUsingGramPanchayat();
  },[])
  const getUserType =async(userTypeId:any)=>{
    try{
    const usertypes = await getDataWithCache<any[]>(`${endpoints.getAllUserTypesWithContext}/${userTypeId}`)
    const usertypesOptions = mapOptions(usertypes.data, (key: any) => ({
      value: key.usertype_name,
      label: key.usertype_name,
      id: key.usertype_id,
      code:key.usertype_code,
    }));
    setUserData((user_details:any) => ({
      ...user_details,
      user_type:{
        ...user_details.user_type,
        '#options': usertypesOptions,
      },
      designation:{
        ...user_details.designation,
        '#options': [],
      },
    }))
  }
  catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  //function to reset all value state
  function resetRoleFormState(fieldsToUpdate: string[]) {
    setRoleFormState((roleState: any) => resetFieldsState(roleState, fieldsToUpdate));
  }

  useEffect(()=>{
    formState1.user_type.id && getUserDesignation(formState1.user_type.id);
    formState1.designation.value ='';
    setRuralUrban('');
    setRuralUrbanId('');
    let fieldsToReset:any =[];
    switch(userTypeName){
      case 'Super Admin User':{
        fieldsToReset = ['role_name','state','zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      };
      case 'National Level User':{
        fieldsToReset = ['role_name','state','zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      };
      case 'State Level User':{
        fieldsToReset = ['role_name','zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      };
      case 'District Level User':{
        fieldsToReset = ['role_name','zone_div_circle','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      };
      default:{
        fieldsToReset = ['role_name','zone_div_circle','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      }
    }
    resetRoleFormState(fieldsToReset);
    if(formState1.user_type.value===USER_TYPE.SUPER_ADMIN){
      const fieldsToUpdate = ['state','zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':true } },
        { keys: ['role_name'], properties: { '#required':false, '#isDisabled':false } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':true } },
      ]));
    }
    else if(formState1.user_type.value===USER_TYPE.NATIONAL_LEVEL){
      const fieldsToUpdate = ['state','zone_div_circle', 'district','sub_district','sub_division','health_block', 'rural_urban', 'ulb','ward','block','village','gram_panchayat']
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':true } },
        { keys: ['role_name'], properties: { '#required':true, '#isDisabled':false } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':false } },
      ]));
    }
    else if(formState1.user_type.value===USER_TYPE.STATE_LEVEL){
      const fieldsToUpdate = ['zone_div_circle','district','sub_district','sub_division','health_block', 'rural_urban', 'ulb','ward','block','village','gram_panchayat']
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':true } },
        { keys: ['state'], properties: { '#required':true, '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_OR_NATIONAL.includes(userTypeName)) ? true : false } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':false } },
      ]));
    }
    else if(formState1.user_type.value === USER_TYPE.ZONE_DIVISION_LEVEL){
      const fieldsToUpdate = ['district','sub_district','sub_division','health_block', 'rural_urban', 'ulb','ward','block','village','gram_panchayat']
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':true } },
        { keys: ['state'], properties: { '#required':true, '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_OR_NATIONAL.includes(userTypeName)) ? true : false } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':true, '#isDisabled':false } },
        { keys: ['district'], properties: { '#required':false, '#isDisabled':true } },
      ]));
    }
    else if(formState1.user_type.value===USER_TYPE.DISTRICT_LEVEL){
      const fieldsToUpdate = ['sub_district','sub_division','health_block', 'rural_urban', 'ulb','ward','block','village','gram_panchayat'];
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':true } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':true } },
        { keys: ['state','district'], properties: { '#required':true, '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_NATIONAL_OR_STATE.includes(userTypeName)) ? (roleFormData.district['#options'].length >= 1 ? false : true) : false } },
        { keys: ['state','district'], properties: { '#required':true, '#isDisabled':([USER_TYPE.DISTRICT_LEVEL].includes(userTypeName)) ? true : false } },
      ]));
    }
    else if(formState1.user_type.value===USER_TYPE.ULB_LEVEL){
      const fieldsToUpdate = ['district','sub_district','sub_division','health_block', 'rural_urban','block','village','ward','gram_panchayat']
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':true } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':true } },
        { keys: ['state'], properties: { '#required':true, '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_OR_NATIONAL.includes(userTypeName)) ? true : false } },
        { keys: ['district'], properties: { '#required':true, '#isDisabled':isLoggedInHierarchyFieldLocked('district') } },
        { keys: ['ulb'], properties: { '#required':true, '#isDisabled':isLoggedInHierarchyFieldLocked('ulb') } },
      ]));
      setRuralUrban(RURAL_URBAN.URBAN);
      setRuralUrbanId(RURAL_URBAN_OPTION_IDS.URBAN);
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'value':RURAL_URBAN.URBAN,
          'id':RURAL_URBAN_OPTION_IDS.URBAN,
          },
        'rural_urban')
      ));
    }
    else if(isSubDistrictUserType(formState1.user_type.value) || isSubDistrictUserType(userTypeName)){
      const fieldsToUpdate = ['ulb','sub_division','health_block', 'ward','block','village','gram_panchayat'];
      const shouldDisableSubDistrictForLoggedInSubDistrictUser =
        isSubDistrictUserType(userTypeName) && isSubDistrictUserType(formState1.user_type.value);
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':true } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':true } },
        { keys: ['state','district'], properties: { '#required':true, '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_NATIONAL_OR_STATE.includes(userTypeName)) ? true : false } },
        { keys: ['sub_district'], properties: { '#required':true, '#isDisabled': shouldDisableSubDistrictForLoggedInSubDistrictUser || isLoggedInHierarchyFieldLocked('sub_district') } },
        { keys: ['rural_urban'], properties: { '#required':false, '#isDisabled':true } },
      ]));
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
          },
        'sub_district')
      ));
    }
    else if(formState1.user_type.value===USER_TYPE.BLOCK_LEVEL){
      const fieldsToUpdate = ['sub_division','health_block','ulb','ward','village','gram_panchayat'];
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':true } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':true } },
        { keys: ['state'], properties: { '#required':true, '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_OR_NATIONAL.includes(userTypeName)) ? true : false } },
        { keys: ['district'], properties: { '#required':true, '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_NATIONAL_OR_STATE.includes(userTypeName)) ? true : false } },
        { keys: ['sub_district'], properties: { '#required':true, '#isDisabled':isLoggedInHierarchyFieldLocked('sub_district') } },
        { keys: ['rural_urban'], properties: { '#required':true, '#isDisabled':true } },
        { keys: ['block'], properties: { '#required':true, '#isDisabled':isLoggedInHierarchyFieldLocked('block') } },
      ]));
      setRuralUrban(RURAL_URBAN.RURAL);
      setRuralUrbanId(RURAL_URBAN_OPTION_IDS.RURAL);
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'value':RURAL_URBAN.RURAL,
          'id':RURAL_URBAN_OPTION_IDS.RURAL,
          },
        'rural_urban')
      ));
    }
    else if(formState1.user_type.value===USER_TYPE.HEALTH_BLOCK_SUB_DIVISION_LEVEL){
      const fieldsToUpdate = ['zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#required':false, '#isDisabled':false } },
        { keys: ['state'], properties: { '#required':true, '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_OR_NATIONAL.includes(userTypeName)) ? true : false } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':true } },
        { keys: ['district'], properties: { '#required':true, '#isDisabled':false } },
        { keys: ['sub_district'], properties: { '#required':true, '#isDisabled':false } },
        { keys: ['rural_urban'], properties: { '#required':false, '#isDisabled':false } },
        { keys: ['ulb'], properties: { '#required':false, '#isDisabled':false } },
        { keys: ['block'], properties: { '#required':false, '#isDisabled':false } },
        { keys: ['health_block'], properties: { '#required':true, '#isDisabled':false } },
        { keys: ['sub_division'], properties: { '#required':false, '#isDisabled':false } },
        { keys: ['ward', 'village', 'gram_panchayat'], properties: { '#required':false, '#isDisabled':true } },
      ]));
    }
    else if(formState1.user_type.value===USER_TYPE.FACILITY_LEVEL || formState1.user_type.value===USER_TYPE.FIELD_LEVEL){
      const fieldsToUpdate = ['sub_division','health_block','sub_district','rural_urban'];
      const shouldEnableWardForUlbCreator = userTypeName === USER_TYPE.ULB_LEVEL;
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: fieldsToUpdate, properties: { '#isDisabled':false } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':true } },
        { keys: ['ulb','block','village','gram_panchayat'], properties: { '#isDisabled':true } },
        { keys: ['ward'], properties: { '#isDisabled': !shouldEnableWardForUlbCreator } },
        { keys: ['state'], properties: { '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_OR_NATIONAL.includes(userTypeName)) ? true : false } },
        { keys: ['district'], properties: { '#isDisabled':(!CREATOR_GROUPS.SUPER_ADMIN_NATIONAL_OR_STATE.includes(userTypeName)) ? true : false } },
      ]));
      const loggedRuralUrbanName = isLoggedInHierarchyFieldLocked('rural_urban') ? loggedInUserDetails?.urban_rural_name?.toLowerCase() : '';
      const loggedRuralUrbanMatch = (roleFormData?.rural_urban?.['#options'] || []).find((option:any) => option.value?.toLowerCase() === loggedRuralUrbanName);
      if (loggedRuralUrbanMatch) {
        setRuralUrban(loggedRuralUrbanMatch.value);
        setRuralUrbanId(loggedRuralUrbanMatch.id);
        // resetRoleFormState() above always blanks rural_urban, so re-apply the match directly (setRuralUrban alone is a no-op when the value hasn't changed)
        setRoleFormState((roleFormState:any) => ({
          ...roleFormState,
          rural_urban: {
            ...roleFormState.rural_urban,
            value: loggedRuralUrbanMatch.value,
            id: loggedRuralUrbanMatch.id,
            code: loggedRuralUrbanMatch.code ?? roleFormState.rural_urban?.code ?? '',
            isError: false,
            message: '',
          },
        }));
      } else {
        
        setRuralUrban('');
      
      }
      const isLockedRuralCreator =
        loggedRuralUrbanMatch?.value === RURAL_URBAN.RURAL &&
        isLoggedInHierarchyFieldLocked('rural_urban');
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: ['rural_urban'], properties: { '#isDisabled': loggedRuralUrbanMatch && isLoggedInHierarchyFieldLocked('rural_urban') ? true : false } },
        { keys: ['state','district','rural_urban'], properties: { '#required':true } },
        { keys: ['sub_division','health_block'], properties: { '#required':false } },
        { keys: ['zone_div_circle'], properties: { '#multiDropdown':false, '#required':false, '#isDisabled':true } },
      ]));
      if (isLockedRuralCreator) {
        setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
          { keys: ['village', 'gram_panchayat'], properties: { '#isDisabled': false } },
          { keys: ['ulb', 'ward'], properties: { '#isDisabled': true } },
        ]));
        setfacilityFormData((facilityDetails: any) => applyFieldRuleGroups(facilityDetails, [
          { keys: ['village', 'gram_panchayat'], properties: { '#isDisabled': false } },
          { keys: ['ward'], properties: { '#isDisabled': true } },
        ]));
        setfieldFormData((fieldDetails: any) => applyFieldRuleGroups(fieldDetails, [
          { keys: ['village', 'gram_panchayat'], properties: { '#isDisabled': false } },
          { keys: ['ward'], properties: { '#isDisabled': true } },
        ]));
      }
      if (isLoggedInHierarchyFieldLocked('sub_district')) {
        setRoleFormData((roleDetails: any) => ({
          ...roleDetails,
          sub_district: {
            ...roleDetails?.sub_district,
            '#isDisabled': true,
            '#required': true,
          },
        }));
      }
    }

    setRoleFormData((roleDetails: any) => ({
      ...roleDetails,
      zone_div_circle: {
        ...roleDetails.zone_div_circle,
        '#multiDropdown': false,
        '#isDisabled': !canEditZoneDivCircle || shouldDisableZoneDivCircleForCreatedUser,
        '#required': canEditZoneDivCircle && !shouldDisableZoneDivCircleForCreatedUser && formState1.user_type.value === USER_TYPE.ZONE_DIVISION_LEVEL,
      },
    }));
  },[formState1.user_type.value])

  useEffect(() => {
    if(formState1.user_type.value===USER_TYPE.HEALTH_BLOCK_SUB_DIVISION_LEVEL){
    if(!roleFormState.health_block.value && !roleFormState.sub_division.value) {
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: ['sub_division', 'health_block'], properties: { '#required': true, '#isDisabled': false } },
      ]));
    }
    else if(roleFormState.health_block.value && !roleFormState.sub_division.value){
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: ['sub_division'], properties: { '#required': false, '#isDisabled': false } },
        { keys: ['health_block'], properties: { '#required': true, '#isDisabled': false } },
      ]));
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'message':'',
          'isError':false,
        },
          'sub_division','health_block')
      ));
    }
    else if(!roleFormState.health_block.value && roleFormState.sub_division.value) {
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: ['health_block'], properties: { '#required': false, '#isDisabled': false } },
        { keys: ['sub_division'], properties: { '#required': true, '#isDisabled': false } },
      ]));
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'message':'',
          'isError':false,
        },
          'sub_division','health_block')
      ));
    }
    else{
      setRoleFormData((roleDetails: any) => applyFieldRuleGroups(roleDetails, [
        { keys: ['sub_division', 'health_block'], properties: { '#required': true, '#isDisabled': false } },
      ]));
    }
  }
  },[roleFormState.health_block.value, roleFormState.sub_division.value])
  
  useEffect(()=>{
    const { roleFormDataPatch, roleFormStatePatch } = getMfaFieldConfig({
      offlineModeAccessValue: roleFormState.offlineModeAccess.value,
    });
    setRoleFormData((role_details:any) => applyFieldPatches(role_details, roleFormDataPatch));
    setRoleFormState((roleFormState:any) => applyFieldPatches(roleFormState, roleFormStatePatch));
  },[roleFormState.offlineModeAccess.value])

  useEffect(()=>{
    const isEligible =
      (formState1?.user_type?.value === USER_TYPE.FACILITY_LEVEL || formState1?.user_type?.value === USER_TYPE.FIELD_LEVEL) &&
      OFFLINE_ENABLED_DESIGNATIONS.includes(formState1?.designation?.value);

    setRoleFormData((role_details:any) =>
      applyFieldPatches(role_details, getOfflineAccessFieldConfig({ isEligible })),
    );

    if (!isEligible) {
      setRoleFormState((roleFormState:any) =>
        applyFieldPatches(roleFormState, {
          offlineModeAccess: { value: false },
        }),
      );
    }
  },[formState1?.user_type?.value, formState1?.designation?.value])
  const getUserDesignation =async(userTypeId:any)=>{
    try{

    const userDesignation = await getData<any[]>(`${endpoints.getUserDesignationWithContext}/${userTypeId}`)
    const userDesignationOptions = mapOptions(userDesignation.data, (key: any) => ({
      value: key.user_designation_name,
      label: key.user_designation_name,
      id: key.user_designation_id,
      code:key.user_designation_code,
    }));
    setUserData((user_details:any) => ({
      ...user_details,
      designation:{
        ...user_details.designation,
        '#options': userDesignationOptions,
      },
    }))
    
  }
  catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }




  useEffect(()=>{
    const isCreatingBlockLevelUser = formState1.user_type.value===USER_TYPE.BLOCK_LEVEL;
    const isSubDistrictLevelUser = isSubDistrictUserType(formState1.user_type.value) || isSubDistrictUserType(userTypeName);
    const isHealthBlockUser = formState1.user_type.value===USER_TYPE.HEALTH_BLOCK_SUB_DIVISION_LEVEL;
   setRoleFormState((prevState: any) => ({
    ...prevState,
    ['rural_urban']: {
      ...prevState['rural_urban'],
      value: ruralUrban,
      isError: false,
      message: '',
      id:ruralUrbanId
    },
  }));
    if (isSubDistrictLevelUser) {
      setRoleFormData((roleDetails: any) => ({
        ...roleDetails,
        rural_urban: {
          ...roleDetails?.rural_urban,
          '#isDisabled': true,
          '#required': false,
        },
      }));
      return;
    }
    if (isLoggedInHierarchyFieldLocked('sub_district') && formState1.user_type.value !== USER_TYPE.BLOCK_LEVEL) {
      setRoleFormData((roleDetails: any) => ({
        ...roleDetails,
        sub_district: {
          ...roleDetails?.sub_district,
          '#isDisabled': true,
          '#required': true,
        },
      }));
    }
    if (isHealthBlockUser) {
      setRoleFormData((roleDetails: any) => ({
        ...roleDetails,
        ward: {
          ...roleDetails?.ward,
          '#isDisabled': true,
          '#required': false,
        },
        village: {
          ...roleDetails?.village,
          '#isDisabled': true,
          '#required': false,
        },
        ulb: {
          ...roleDetails?.ulb,
          '#isDisabled': ruralUrban === RURAL_URBAN.RURAL,
          '#required': ruralUrban === RURAL_URBAN.RURAL ? false : roleDetails?.ulb?.['#required'],
        },
        block: {
          ...roleDetails?.block,
          '#isDisabled': ruralUrban === RURAL_URBAN.URBAN,
          '#required': ruralUrban === RURAL_URBAN.URBAN ? false : roleDetails?.block?.['#required'],
        },
        sub_district: {
          ...roleDetails?.sub_district,
          '#isDisabled': ruralUrban === RURAL_URBAN.URBAN,
          '#required': ruralUrban === RURAL_URBAN.URBAN ? false : roleDetails?.sub_district?.['#required'],
        },
      }));
      setRoleFormState((roleState: any) => (
        setIsFieldDisabledOrRequired(roleState, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
        }, 'ward','village'))
      );
      return;
    }
    if(ruralUrban===RURAL_URBAN.RURAL){
      setRoleFormState((roleState: any) => (
        setIsFieldDisabledOrRequired(roleState, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setRoleFormData((role_details:any) => ({
        ...role_details,
        ulb:{
          ...role_details?.ulb,
          '#isDisabled':true,
          '#required': false, 
        },
        ward:{
          ...role_details?.ward,
          '#isDisabled':true,
          '#required': false, 
        },
        village:{
          ...role_details?.village,
          '#isDisabled': isCreatingBlockLevelUser ? true : isLoggedInHierarchyFieldLocked('village'), 
          '#required': isCreatingBlockLevelUser ? false : true,
        },
        gram_panchayat:{
          ...role_details?.gram_panchayat,
          '#isDisabled':isCreatingBlockLevelUser,
          '#required': isCreatingBlockLevelUser ? false : true,
        },
        block:{
          ...role_details?.block,
          '#required': hasBlocksForDistrict === false ? false : true,
          '#isDisabled': hasBlocksForDistrict === false ? true : isLoggedInHierarchyFieldLocked('block'),

        },

      }))
      setfieldFormData((facility_details:any) => ({
        ...facility_details,
        ward:{
          ...facility_details?.ward,
          '#isDisabled':true,
          '#options':[]
        },
        village:{
          ...facility_details?.village,
          '#isDisabled':isCreatingBlockLevelUser,
          '#required': isCreatingBlockLevelUser ? false : fieldFormData.village['#options'].length?true:false,
        },
        gram_panchayat:{
          ...facility_details?.gram_panchayat,
          '#isDisabled':isCreatingBlockLevelUser,
          '#required': isCreatingBlockLevelUser ? false : fieldFormData.gram_panchayat['#options'].length?true:false,
        },
      }))
      setfacilityFormData((facility_details:any) => ({
        ...facility_details,
        ward:{
          ...facility_details?.ward,
          '#isDisabled':true, 
          '#options':[]
        },
        village:{
          ...facility_details?.village,
          '#isDisabled':isCreatingBlockLevelUser,
          '#required': isCreatingBlockLevelUser ? false : facilityFormData.village['#options'].length?true:false,
        },
        gram_panchayat:{
          ...facility_details?.gram_panchayat,
          '#isDisabled':isCreatingBlockLevelUser,
          '#required': isCreatingBlockLevelUser ? false : fieldFormData.gram_panchayat['#options'].length?true:false,
        },
      }));
      setFormStateForFacility((roleFormState:any) => applyFieldPatches(roleFormState, {
        ward: { value: '', isError:false, message:'', id:[], code:[] },
        village: isCreatingBlockLevelUser ? { value: '', isError:false, message:'', id:[], code:[] } : roleFormState.village,
        gram_panchayat: isCreatingBlockLevelUser ? { value: '', isError:false, message:'', id:[], code:[] } : roleFormState.gram_panchayat,
      }))
      setFormStateForField((roleFormState:any) => applyFieldPatches(roleFormState, {
        ward: { value: '', id: [], code:[], isError:false, message:'' },
        village: isCreatingBlockLevelUser ? { value: '', id: [], code:[], isError:false, message:'' } : roleFormState.village,
        gram_panchayat: isCreatingBlockLevelUser ? { value: '', id: [], code:[], isError:false, message:'' } : roleFormState.gram_panchayat,
      }))


     

   
   }
    else if(ruralUrban===RURAL_URBAN.URBAN) {
      const shouldKeepUlbDisabledForNationalUser =
        userTypeName === USER_TYPE.NATIONAL_LEVEL &&
        ![USER_TYPE.FACILITY_LEVEL, USER_TYPE.FIELD_LEVEL, USER_TYPE.ULB_LEVEL].includes(formState1.user_type.value);
      setRoleFormState((roleState: any) => (
        setIsFieldDisabledOrRequired(roleState, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setRoleFormData((role_details:any) => ({
        ...role_details,
        ulb:{
          ...role_details?.ulb,
          '#isDisabled': isLoggedInHierarchyFieldLocked('ulb') || shouldKeepUlbDisabledForNationalUser,
          '#required': true,
        },
        ward:{
          ...role_details?.ward,
          '#isDisabled': formState1.user_type.value === USER_TYPE.ULB_LEVEL ? true : isLoggedInHierarchyFieldLocked('ward'),
          '#required': formState1.user_type.value === USER_TYPE.ULB_LEVEL ? false : true,
        },
        village:{
          ...role_details?.village,
          '#isDisabled':true,
          '#required': false, 
        },
        gram_panchayat:{
          ...role_details?.gram_panchayat,
          '#isDisabled':true,
          '#required': false, 
        },
        block:{
          ...role_details?.block,
          '#isDisabled':true,
          '#required': false, 
        },

      }))
      setfieldFormData((field_details:any) => ({
        ...field_details,
        ward:{
          ...field_details?.ward,
          '#isDisabled':false, 
          '#required': fieldFormData.ward['#options'].length?true:false,
        },
        village:{
          ...field_details?.village,
          '#isDisabled':true,
          '#options':[],
        },
        gram_panchayat:{
          ...field_details?.gram_panchayat,
          '#isDisabled':true,
          '#options':[],
        },
      }))
      setfacilityFormData((facility_details:any) => ({
        ...facility_details,
        ward:{
          ...facility_details?.ward,
          '#isDisabled':false,
          '#required': facilityFormData.ward['#options'].length?true:false,
        },
        village:{
          ...facility_details?.village,
          '#isDisabled':true,
          '#options':[],
        },
        gram_panchayat:{
          ...facility_details?.gram_panchayat,
          '#isDisabled':true,
          '#options':[],
        },
      }))
      setFormStateForFacility((roleFormState:any) => applyFieldPatches(roleFormState, {
        village: { value: '', isError:false, message:'', id:[], code:[] },
        gram_panchayat: { value: '', isError:false, message:'', id:[], code:[] },
      }))
      setFormStateForField((roleFormState:any) => applyFieldPatches(roleFormState, {
        village: { value: '', id: [], code:[], isError:false, message:'' },
        gram_panchayat: { value: '', id: [], code:[], isError:false, message:'' },
      }))
      
    }
    else if(ruralUrban==='' || ruralUrban === null || ruralUrban===undefined){
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':true,
          '#required':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setfieldFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':true,
          '#required':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setfacilityFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':true,
          '#required':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setRoleFormState((roleState: any) => (
        setIsFieldDisabledOrRequired(roleState, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setFormStateForFacility((roleState: any) => applyFieldPatches(roleState, {
        ulb: { value:'', id:'', code:'', message:'', isError:false },
        block: { value:'', id:'', code:'', message:'', isError:false },
        ward: { value:'', id:'', code:'', message:'', isError:false },
        village: { value:'', id:'', code:'', message:'', isError:false },
        gram_panchayat: { value:'', id:'', code:'', message:'', isError:false },
      }));
      setFormStateForField((roleState: any) => applyFieldPatches(roleState, {
        ulb: { value:'', id:'', code:'', message:'', isError:false },
        block: { value:'', id:'', code:'', message:'', isError:false },
        ward: { value:'', id:'', code:'', message:'', isError:false },
        village: { value:'', id:'', code:'', message:'', isError:false },
        gram_panchayat: { value:'', id:'', code:'', message:'', isError:false },
      }));  

    }
  },[ruralUrban, hasBlocksForDistrict])

  const getVillageByFacility=async ()=>{
    const facilityID= formState1?.user_type?.value==='Facility Level User'?formStateForFacility?.health_facility_name?.id:formStateForField?.health_facility_name?.id;
    if(facilityID){
      const village = await getData<any[]>(`${endpoints.getVillageByFacilityId(facilityID)}`);
      const villageOptions = village.data.map((option1: any) => ({
        value: option1.village_name,
        label: option1.village_name,
        id: option1.village_id,
        code: option1.village_code,
      }));
  
    if(formState1.user_type.value==='Facility Level User'){
      setfacilityFormData((role_details:any) => ({
        ...role_details,
        village: {
          ...role_details.village,
          '#options': villageOptions,
          '#required': villageOptions.length && role_details.village['#isDisabled'] === false ? true :false,
        },
        ward:{
          ...role_details.ward,
          '#required': role_details.ward['#isDisabled'] === true ? false : true
        }
  
      }))
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        village: {
          ...roleFormState.village,
          value: roleFormState.village.value,
          id: roleFormState.village.id
        },
      }))
    }
    else{
      setfieldFormData((role_details:any) => ({
        ...role_details,
        village: {
          ...role_details.village,
          '#options': villageOptions,
          '#required': villageOptions.length && role_details.village['#isDisabled'] === false ? true :false,
        },
        ward:{
          ...role_details.ward,
          '#required': role_details.ward['#isDisabled'] === true ? false : true
        }
      }))
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        village: {
          ...roleFormState.village,
          value: roleFormState.village.value,
          id: roleFormState.village.id
        },
      }))
    }
    }
  }

  const getGramPanchayatByFacility=async ()=>{
    const facilityID= formState1?.user_type?.value==='Facility Level User'?formStateForFacility?.health_facility_name?.id:formStateForField?.health_facility_name?.id;
    if(facilityID){
      const gramPanchayat = await getData<any[]>(`${endpoints.getGramPanchayatCoverageByFacilityId(facilityID)}`);
      const gramPanchayatOptions = gramPanchayat.data.map((option1: any) => ({
        value: option1.gram_panchayat_name,
        label: option1.gram_panchayat_name,
        id: option1.gram_panchayat_id,
        code: option1.gram_panchayat_code,
      }));
  
    if(formState1.user_type.value==='Facility Level User'){
      setfacilityFormData((role_details:any) => ({
        ...role_details,
        gram_panchayat: {
          ...role_details.gram_panchayat,
          '#options': gramPanchayatOptions,
          '#required': gramPanchayatOptions.length && role_details.gram_panchayat['#isDisabled'] === false ? true :false,
        },
  
      }))
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: roleFormState.gram_panchayat.value,
          id: roleFormState.gram_panchayat.id
        },
      }))
    }
    else{
      setfieldFormData((role_details:any) => ({
        ...role_details,
        gram_panchayat: {
          ...role_details.gram_panchayat,
          '#options': gramPanchayatOptions,
          '#required': gramPanchayatOptions.length && role_details.gram_panchayat['#isDisabled'] === false ? true :false,
        },
  
      }))
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: roleFormState.gram_panchayat.value,
          id: roleFormState.gram_panchayat.id
        },
      }))
    }
    }
  }

  const getWardByFacility=async ()=>{
    const facilityID = formState1?.user_type?.value==='Facility Level User'?formStateForFacility?.health_facility_name?.id:formStateForField?.health_facility_name?.id;
    if (facilityID)
      {
        const ward = await getData<any[]>(`${endpoints.getWardByFacilityId(facilityID)}`);
        const wardOptions = ward.data.map((key: any) => ({
        value: key.ward_name,
        label: key.ward_name,
        id: key.ward_id,
        code: key.ward_code
      }));
    
    if(formState1.user_type.value==='Facility Level User'){
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: '',
          id:[],
          code:[]
        },
      }))
      setfacilityFormData((role_details:any) => ({
        ...role_details,
        ward: {
          ...role_details.ward,
          '#options': [],
        },
      }))
      setfacilityFormData((role_details:any) => ({
        ...role_details,
        ward: {
          ...role_details.ward,
          '#options': wardOptions,
          '#required': wardOptions.length && role_details.ward['#isDisabled'] === false ? true :false,
        },
        village:{
          ...role_details.village,
          '#required': role_details.village['#isDisabled'] === false ? true :false,
        }
      }))
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: roleFormState.ward.value,
          id: roleFormState.ward.id
        },
      }))
    }
    else{
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: '',
          id: [],
          code:[]
        },
      }))
      setfieldFormData((role_details:any) => ({
        ...role_details,
        ward: {
          ...role_details.ward,
          '#options': [],
        }
      }))
     
      setfieldFormData((role_details:any) => ({
        ...role_details,
        ward: {
          ...role_details.ward,
          '#options': wardOptions,
          '#required': wardOptions.length && role_details.ward['#isDisabled'] === false ? true :false,
        },
        village:{
          ...role_details.village,
          '#required': role_details.village['#isDisabled'] === false ? true :false,
        }
      }))
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: roleFormState.ward.value,
          id: roleFormState.ward.id
        },
      }))
    }
  }
  }

  useEffect(()=>{
    try{
      if((formStateForFacility.health_facility_name.value!=='' && formStateForFacility.health_facility_name.value!==undefined )
      ||(formStateForField.health_facility_name.value!=='' && formStateForField.health_facility_name.value!==undefined)){
    if(ruralUrban===RURAL_URBAN.RURAL){
      isGrampanchayat? getGramPanchayatByFacility() : getVillageByFacility();
    }
    else{
      getWardByFacility();
    }
  }
  else{
    setFormStateForFacility((roleFormState:any) => ({
      ...roleFormState,
      village: {
        ...roleFormState.village,
        value: '',
        id:[],
        code:[]
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id:[],
        code:[]
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: ''
      },
    }))
    setfacilityFormData((role_details:any) => ({
      ...role_details,
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
      ward: {
        ...role_details.ward,
        '#options': [],
      },
    }))
    setFormStateForField((roleFormState:any) => ({
      ...roleFormState,
      village: {
        ...roleFormState.village,
        value: '',
        id: [],
        code:[]
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: [],
        code:[]
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: [],
        code:[]
      },
    }))
    setfieldFormData((role_details:any) => ({
      ...role_details,
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
      ward: {
        ...role_details.ward,
        '#options': [],
      },

    }))
  }
  
  }
  catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  },[formStateForFacility.health_facility_name.value,formStateForField.health_facility_name.value])


  useEffect(()=>{
    setUserData((user_details:any) => ({
      ...user_details,
      fName:{
        ...user_details.fName,
        '#required': true,
        '#isDisabled':false,

      },
      lName:{
        ...user_details.lName,
        '#isDisabled':false,
        '#required': true,
      },
    }))
    dispatch(updateForm("isVerified",'false'));
    if(formState1.user_type.id && formState1.designation.id)
      {
        getRoles(formState1.user_type.id, formState1.designation.id);
      }
  },[formState1.user_type.id,formState1.designation.id]);
  useEffect(()=>{
    (async () => {
     
      await getRuralOrUrban();
      getStates();
    })();
  },[]);
  
  useEffect(()=>{
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      zone_div_circle: { ...roleFormState.zone_div_circle, value: '', id: '' },
      district: { ...roleFormState.district, value: '', id: '' },
      sub_district: { ...roleFormState.sub_district, value: '', id: '' },
      health_block: { ...roleFormState.health_block, value: '', id: '' },
      sub_division: { ...roleFormState.health_block, value: '', id: '' },
      ulb: { ...roleFormState.ulb, value: '', id: '' },
      ward: { ...roleFormState.ward, value: '', id: '' },
      block: { ...roleFormState.block, value: '', id: '' },
      village: { ...roleFormState.village, value: '', id: '' },
      gram_panchayat: { ...roleFormState.gram_panchayat, value: '', id: '' },
    }))
    if(roleFormState.state.id)
      {
        checkIfUsingGramPanchayat();
        getULB(roleFormState.state.id);
        getZoneDicCircle(roleFormState.state.id);
        getDistrictForState(roleFormState.state.id);
      }
    else{
      setRoleFormData((role_details:any) => ({
        ...role_details,
        zone_div_circle: {
          ...role_details.zone_div_circle,
          '#options': [],
        },
        district: {
          ...role_details.district,
          '#options': [],
        },
        sub_district: {
          ...role_details.sub_district,
          '#options': [],
        },
        health_block: {
          ...role_details.health_block,
          '#options':[],
        },
        ward: {
          ...role_details.ward,
          '#options':[],
        },
        sub_division: {
          ...role_details.sub_division,
          '#options': [],
        },
        block: {
          ...role_details.block,
          '#options': [],
        },
        village: {
          ...role_details.village,
          '#options': [],
        },
        gram_panchayat: {
          ...role_details.gram_panchayat,
          '#options': [],
        },
      }))
    }
  },[roleFormState.state.id]);

  useEffect(() => {
    const shouldLoadDistrictHierarchy = [
      USER_TYPE.BLOCK_LEVEL,
      USER_TYPE.FACILITY_LEVEL,
      USER_TYPE.FIELD_LEVEL,
      USER_TYPE.HEALTH_BLOCK_SUB_DIVISION_LEVEL,
    ].includes(formState1.user_type.value);

    if (!shouldLoadDistrictHierarchy) return;
    if (ruralUrban !== RURAL_URBAN.RURAL) return;
    if (!roleFormState.district?.id) return;

    getSubDistBlock(roleFormState.district.id);
  }, [formState1.user_type.value, roleFormState.district?.id, ruralUrban]);

  const getRuralOrUrban=async()=>{
    try {
    const roles = await getDataWithCache<any[]>(`${endpoints.getRuralUrbal}`)
    const ruralOrUrban_options = mapRuralUrbanOptions(roles.data);
    setRoleFormData((role_details:any) => ({
      ...role_details,
      rural_urban:{
        ...role_details.rural_urban,
        '#options': ruralOrUrban_options,
      },
    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
     
      ulb: {
        ...roleFormState.ulb,
        value: '',
        id: '',
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))

    const loggedUrbanRuralName = isLoggedInHierarchyFieldLocked('rural_urban')
      ? loggedInUserDetails?.urban_rural_name?.toLowerCase()
      : '';
    const loggedUrbanRuralMatch = ruralOrUrban_options.find((option: any) => {
      const optionValue = option.value?.toLowerCase();
      return optionValue === loggedUrbanRuralName || optionValue === `${loggedUrbanRuralName}`;
    });
    if (loggedUrbanRuralMatch) {
      const nextRuralUrbanValue = loggedUrbanRuralMatch.value;
      setRuralUrban(nextRuralUrbanValue);
      setRuralUrbanId(loggedUrbanRuralMatch.id);
      setRoleFormState((prevState: any) => ({
        ...prevState,
        rural_urban: {
          ...prevState.rural_urban,
          value: nextRuralUrbanValue,
          id: loggedUrbanRuralMatch.id,
          code: loggedUrbanRuralMatch.code ?? prevState.rural_urban?.code ?? '',
        },
      }));
    }
         
  }    catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  const getRoles =async(userTypeId:any, userDesignationId:any)=>{
    try{
    const roles = await getDataWithCache<any[]>(`${endpoints.getAllRoles(userTypeId,userDesignationId)}`)
    if(formState1.user_type.value==='Field Level User'){
      const rolesOptions = roles.data
  .filter((key: any) => key.role_name === 'Service Provider')
  .map((key: any) => ({
    value: key.role_name,
    label: key.role_name,
    id: key.role_id,
    code: key.role_code,
    compositeRoleId:key.composite_role_id
  }));
  setRoleFormData((role_details:any) => ({
    ...role_details,
    role_name:{
      ...role_details.role_name,
      '#options': rolesOptions,
    },
  }))
  setRoleFormState((roleFormState:any) => ({
    ...roleFormState,
    role_name:{
      ...roleFormState.role_name,
      value:roleFormState.role_name.value,
      id:roleFormState.role_name.id,
      code:roleFormState.role_name.code,
      compositeRoleId:roleFormState.role_name.compositeRoleId,
    },
  }))

    }
    else{
    const rolesOptions = roles.data.map((key: any) => ({
      value: key.role_name,
      label: key.role_name,
      id: key.role_id,
      code: key.role_code,
      compositeRoleId: key.composite_role_id
    }));
    setRoleFormData((role_details:any) => ({
      ...role_details,
      role_name:{
        ...role_details.role_name,
        '#options': rolesOptions,
      },
    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      role_name:{
        ...roleFormState.role_name,
        value:roleFormState.role_name.value,
        id:roleFormState.role_name.id,
        code:roleFormState.role_name.code,
        compositeRoleId:roleFormState.role_name.compositeRoleId,
      },
    }))
  }
}     catch(error:any){
  errorLogger(error?.response?.data||error?.response||error)
}
  }
  const getStates=async ()=>{
    try{
    const states = await getDataWithCache<any[]>(`${endpoints.getStates}`);
    const stateOptions = mapStateOptions(states.data);
    setRoleFormData((role_details:any) => ({
      ...role_details,
      state:{
        ...role_details.state,
        '#options': stateOptions,
        '#isDisabled': states.data.length === 1 ? true : false,
      },
      zone_div_circle: {
        ...role_details.zone_div_circle,
        '#options': [],
      },
      district: {
        ...role_details.district,
        '#options': [],
      },
      sub_district: {
        ...role_details.sub_district,
        '#options': [],
      },
      health_block: {
        ...role_details.health_block,
        '#options':[],
      },
      ulb: {
        ...role_details.ulb,
        '#options': [],
      },
      ward: {
        ...role_details.ward,
        '#options':[],
      },
      sub_division: {
        ...role_details.sub_division,
        '#options': [],
      },
      block: {
        ...role_details.block,
        '#options': [],
      },
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
    }))
    const loggedInStateMatch = isLoggedInHierarchyFieldLocked('state')
      ? findMatchedOption(stateOptions, loggedInUserDetails?.state_id)
      : undefined;
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      state:{
        ...roleFormState.state,
        value: states.data.length === 1 ? `${states.data[0].state_name}-${states.data[0].state_code}` : (loggedInStateMatch ? loggedInStateMatch.value : ''),
        id: states.data.length === 1 ? `${states.data[0].state_id}` : (loggedInStateMatch ? String(loggedInStateMatch.id) : ''),
        code: states.data.length === 1 ? states.data[0].state_code : (loggedInStateMatch ? loggedInStateMatch.code : null),
      },
      district: {
        ...roleFormState.district,
        value: '',
        id: '',
      },
      sub_district: {
        ...roleFormState.sub_district,
        value: '',
        id: '',
      },
      health_block: {
        ...roleFormState.health_block,
        value: '',
        id: '',
      },
      sub_division: {
        ...roleFormState.health_block,
        value: '',
        id: '',
      },
      ulb: {
        ...roleFormState.ulb,
        value: '',
        id: '',
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))
    if(states.data.length === 1){
      checkIfUsingGramPanchayat();
    }
  } catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
}
  }

  const getZoneDicCircle=async (stateId:any)=>{
    try{
    const ZoneDicCircles = await getData<any[]>(`${endpoints.getZoneByState}/${stateId}`);
    const ZDCOptions = mapZoneDivisionOptions(ZoneDicCircles.data);
    ZDCOptions.length? setHasZonesCreated(true): setHasZonesCreated(false);

    setRoleFormData((role_details:any) => ({
      ...role_details,
      zone_div_circle: {
        ...role_details.zone_div_circle,
        '#options': ZDCOptions,
        '#required': canEditZoneDivCircle && formState1.user_type.value === USER_TYPE.ZONE_DIVISION_LEVEL ? (ZDCOptions.length ? true : false) : false,
      },
    }));
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      zone_div_circle: {
        ...roleFormState.zone_div_circle,
        value: '',
        id: '',
      }
    }));
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  const getDistrictForState = async (stateId:any, config?:any)=>{
    try{
    if(stateId){
      const districts = await getData<any[]>(`${endpoints.getDistricts(stateId)}`);
      setDistrictOptions(districts, config)
    }
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  const getDistrictForZDC = async (ZDCId:any, config?:any)=>{
    try{
    if(ZDCId){
      const districts = await getData<any[]>(`${endpoints.getDistrictsByZDCId(ZDCId)}`);
      setDistrictOptions(districts, config)
    }
  }    catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  const setDistrictOptions=async (districts:any, config:any = {})=>{
    const { forceClearSelection = false, allowAutoSelectSingle = true } = config;
    const isZoneDivisionUser = formState1.user_type.value === USER_TYPE.ZONE_DIVISION_LEVEL;
    const distOptions = mapDistrictOptions(districts.data);
    const selectedDistrictId = String(roleFormState?.district?.id || '');
    const selectedDistrictStillApplies = !!selectedDistrictId && distOptions.some((option:any) => String(option.id) === selectedDistrictId);
    const hasLowerHierarchySelection = !!roleFormState?.sub_district?.id || !!roleFormState?.block?.id || !!roleFormState?.ulb?.id || !!roleFormState?.ward?.id || !!roleFormState?.village?.id || !!roleFormState?.gram_panchayat?.id;
    const shouldResetLowerHierarchy = !selectedDistrictStillApplies && (selectedDistrictId || hasLowerHierarchySelection);

    setRoleFormData((role_details:any) => {
      const updatedRoleDetails = {
        ...role_details,
        district: {
          ...role_details.district,
          '#options': distOptions,
          '#required':([USER_TYPE.SUPER_ADMIN, USER_TYPE.NATIONAL_LEVEL, USER_TYPE.STATE_LEVEL, USER_TYPE.ZONE_DIVISION_LEVEL, USER_TYPE.ULB_LEVEL].includes(formState1.user_type.value)) ? false : true,
        },
      };

      if (shouldResetLowerHierarchy) {
        updatedRoleDetails.ward = {
          ...updatedRoleDetails.ward,
          '#options': [],
        };
        updatedRoleDetails.village = {
          ...updatedRoleDetails.village,
          '#options': [],
        };
        updatedRoleDetails.gram_panchayat = {
          ...updatedRoleDetails.gram_panchayat,
          '#options': [],
        };
      }

      return updatedRoleDetails;
    });

    const loggedInDistrictMatch = findMatchedOption(distOptions, loggedInUserDetails?.district_id);
    const hasSingleDistrictOption = districts.data.length === 1;
    const shouldAutoSelectDistrict =
      !forceClearSelection && !isZoneDivisionUser && (
        (allowAutoSelectSingle && hasSingleDistrictOption) ||
        isLoggedInHierarchyFieldLocked('district') ||
        (!!loggedInUserDetails?.district_id && !roleFormState?.district?.value && !!loggedInDistrictMatch)
      );
    setRoleFormState((roleFormState:any) => {
      const currentDistrictId = String(roleFormState?.district?.id || '');
      const currentDistrictValue = roleFormState?.district?.value || '';
      const currentDistrictCode = roleFormState?.district?.code || '';
      const currentDistrictStillApplies = !!currentDistrictId && distOptions.some((option:any) => String(option.id) === currentDistrictId);
      const nextDistrictValue = shouldAutoSelectDistrict
        ? (hasSingleDistrictOption ? `${districts.data[0].district_name}-${districts.data[0].district_code}` : (loggedInDistrictMatch ? loggedInDistrictMatch.value : currentDistrictStillApplies ? currentDistrictValue : ''))
        : (currentDistrictStillApplies ? currentDistrictValue : '');
      const nextDistrictId = shouldAutoSelectDistrict
        ? (hasSingleDistrictOption ? `${districts.data[0].district_id}` : (loggedInDistrictMatch ? String(loggedInDistrictMatch.id) : currentDistrictStillApplies ? String(currentDistrictId) : ''))
        : (currentDistrictStillApplies ? String(currentDistrictId) : '');
      const nextDistrictCode = shouldAutoSelectDistrict
        ? (hasSingleDistrictOption ? `${districts.data[0].district_code}` : (loggedInDistrictMatch ? loggedInDistrictMatch.code : currentDistrictStillApplies ? currentDistrictCode : ''))
        : (currentDistrictStillApplies ? currentDistrictCode : '');

      const nextState = {
        ...roleFormState,
        district: {
          ...roleFormState.district,
          value: nextDistrictValue,
          id: nextDistrictId,
          code: nextDistrictCode,
        },
      };

      if (shouldResetLowerHierarchy) {
        nextState.ward = {
          ...nextState.ward,
          value: '',
          id: '',
          code: '',
        };
        nextState.village = {
          ...nextState.village,
          value: '',
          id: '',
          code: '',
        };
        nextState.gram_panchayat = {
          ...nextState.gram_panchayat,
          value: '',
          id: '',
          code: '',
        };
      }

      return nextState;
    })
  }

  useEffect(() => {
    if (
      userTypeName === USER_TYPE.STATE_LEVEL &&
      formState1.user_type.value !== USER_TYPE.STATE_LEVEL &&
      formState1.user_type.value !== USER_TYPE.ZONE_DIVISION_LEVEL &&
      (roleFormData.district['#options'] || []).length > 0
    ) {
      setRoleFormData((roleDetails: any) => ({
        ...roleDetails,
        district: {
          ...roleDetails.district,
          '#isDisabled': false,
        },
      }));
    }
  }, [userTypeName, formState1.user_type.value, roleFormData.district['#options']]);

  const fecthUlbBySearch = async (ulbInputText:string) => {
    const getUlbwithsearch = await axios.get(`${endpoints.fetchUlbByStateIdAndSearch(roleFormState?.state?.id, ulbInputText)}`,Auth.loggedIn());
    const getUlb_options = mapUlbOptions(getUlbwithsearch?.data?.data);
    setRoleFormData((hierarchy_details_urban: any) => ({
      ...hierarchy_details_urban,
      ulb: {
        ...hierarchy_details_urban.ulb,
        '#options': getUlb_options,
        '#required': true,
        '#isDisabled': false,
      },
    }));
  }

  useEffect(()=>{

    if(roleFormData?.ulb?.['#isDisabled'] === false && !isLoggedInHierarchyFieldLocked('ulb') && roleFormState?.state?.id && ulbInputText?.length >= 3){
      fecthUlbBySearch(ulbInputText)
    }
    if(ulbInputText?.length === 0)
      {
        setRoleFormData((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          ulb: {
            ...hierarchy_details_urban.ulb,
            '#options': [],
          },
        }));
      }
  },[ulbInputText, roleFormData?.ulb?.['#isDisabled'], roleFormState?.state?.id])

  useEffect(() => {
    if (
      ruralUrban === RURAL_URBAN.URBAN &&
      roleFormState?.state?.id
    ) {
      getULB(roleFormState.state.id);
    }
  }, [ruralUrban, roleFormState?.state?.id]);

  const getULB=async (_stateId:any)=>{
    try{
    const ulbResponse = await getData<any[]>(`${endpoints.getUlb(_stateId)}`);
    const ulbOptions = mapUlbOptions(ulbResponse.data);
    const loggedUlb = (isLoggedInHierarchyFieldLocked('ulb') || (!!loggedInUserDetails?.ulb_id && !roleFormState?.ulb?.value)) && loggedInUserDetails?.ulb_id ? {
      value: loggedInUserDetails?.ulb_name ? `${loggedInUserDetails.ulb_name}-${loggedInUserDetails.ulb_code}` : '',
      label: loggedInUserDetails?.ulb_name ? `${loggedInUserDetails.ulb_name}-${loggedInUserDetails.ulb_code}` : '',
      id: loggedInUserDetails.ulb_id,
      code: loggedInUserDetails.ulb_code,
    } : undefined;
    setRoleFormData((role_details:any) => ({
      ...role_details,
    
      ulb: {
        ...role_details.ulb,
        '#options': loggedUlb ? [loggedUlb] : ulbOptions,
        '#isDisabled' : role_details.ulb['#isDisabled'] || !!loggedUlb,
        '#required': loggedUlb ? true : (role_details.ulb['#isDisabled'] === false ? true : false),
      },
      ward: {
        ...role_details.ward,
        '#options':[],
      },
      block: {
        ...role_details.block,
        '#options': [],
      },
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      ulb: loggedUlb ? {
        ...roleFormState.ulb,
        value: loggedUlb.value,
        id: String(loggedUlb.id),
        code: loggedUlb.code,
      } : {
        ...roleFormState.ulb,
        value: '',
        id: '',
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  const handleInputChange = useDebouncedCallback((value:string, key:string) => {
    if(key === 'ulb'){
      setUlbInputText(value.trim());
    }
  }, 500);
  
  const getSubDistBlock = async (districtId: any) => {
    try {
      const [subDistrictResult, healthBlockResult, subDivisionResult, blockResult] = await Promise.allSettled([
        getData<any[]>(`${endpoints.getSubDistricts(districtId)}`),
        getData<any[]>(`${endpoints.getHealthBlock(districtId)}`),
        getData<any[]>(`${endpoints.getSubDivision(districtId)}`),
        getData<any[]>(`${endpoints.getBlock(districtId)}`),
      ]);

      const getSubDist = subDistrictResult.status === 'fulfilled' ? subDistrictResult.value : { data: [] };
      const getHealthBlock = healthBlockResult.status === 'fulfilled' ? healthBlockResult.value : { data: [] };
      const subDivision = subDivisionResult.status === 'fulfilled' ? subDivisionResult.value : { data: [] };
      const getBlock = blockResult.status === 'fulfilled' ? blockResult.value : { data: [] };

      const subDistOptions = mapSubDistrictOptions(getSubDist.data);
      const healthBlockOptions = mapHealthBlockOptions(getHealthBlock.data);
      const subDivisionOptions = mapSubDivisionOptions(subDivision.data);
      const getBlockOptions = mapBlockOptions(getBlock.data);
      setHasBlocksForDistrict(getBlockOptions.length > 0);
      const loggedInSubDistrictMatch = isLoggedInHierarchyFieldLocked('sub_district')
        ? findMatchedOption(subDistOptions, loggedInUserDetails?.sub_district_id)
        : undefined;
      const loggedInBlockMatch = isLoggedInHierarchyFieldLocked('block')
        ? findMatchedOption(getBlockOptions, loggedInUserDetails?.block_id)
        : undefined;
      const shouldDisableSubDistrictForLoggedInSubDistrictUser =
        isSubDistrictUserType(userTypeName) && isSubDistrictUserType(formState1.user_type.value);
      setRoleFormData((roleFormData: any) => ({
        ...roleFormData,
        sub_district: {
          ...roleFormData.sub_district,
          '#options': subDistOptions,
          '#required': (subDistOptions.length > 0 && !roleFormData.sub_district['#isDisabled']),
          '#isDisabled': shouldDisableSubDistrictForLoggedInSubDistrictUser || roleFormData.sub_district['#isDisabled'] || isLoggedInHierarchyFieldLocked('sub_district'),
        },
        health_block: {
          ...roleFormData.health_block,
          '#options': healthBlockOptions,
          '#required': formState1.user_type.value === 'Health Block/ Sub Division Level User'? true : false,
        }, 
        sub_division: {
          ...roleFormData.sub_division,
          '#options': subDivisionOptions,
          '#required': formState1.user_type.value === 'Health Block/ Sub Division Level User'? true : false,
        },
      
        block: {
          ...roleFormData.block,
          '#options': loggedInBlockMatch ? [loggedInBlockMatch] : getBlockOptions,
          '#isDisabled': loggedInBlockMatch ? true : (getBlockOptions.length === 0 ? true : roleFormData.block['#isDisabled']),
          '#required': loggedInBlockMatch ? true : ((getBlockOptions.length && roleFormData.block['#isDisabled'] === false) ? true : false),

        },
        village: {
          ...roleFormData.village,
          '#options': [],
        },
        gram_panchayat: {
          ...roleFormData.gram_panchayat,
          '#options': [],
        },
      }));
      if (loggedInBlockMatch) {
        setRoleFormState((prevState: any) => ({
          ...prevState,
          block: {
            ...prevState.block,
            value: loggedInBlockMatch.value,
            id: String(loggedInBlockMatch.id),
            code: loggedInBlockMatch.code ?? prevState.block?.code ?? '',
          },
        }));
      }
      setRoleFormState((roleFormState: any) => ({
        ...roleFormState,
        sub_district: {
          ...roleFormState.sub_district,
          value: roleFormState.sub_district.value || (loggedInSubDistrictMatch ? loggedInSubDistrictMatch.value : ''),
          id: roleFormState.sub_district.id || (loggedInSubDistrictMatch ? String(loggedInSubDistrictMatch.id) : ''),
          code: roleFormState.sub_district.code || (loggedInSubDistrictMatch ? loggedInSubDistrictMatch.code : ''),
        },
        health_block: {
          ...roleFormState.health_block,
          value: roleFormState.health_block.value || (isLoggedInHierarchyFieldLocked('health_block') ? findMatchedOption(healthBlockOptions, loggedInUserDetails?.health_block_id)?.value || '' : ''),
          id: roleFormState.health_block.id || (isLoggedInHierarchyFieldLocked('health_block') ? String(findMatchedOption(healthBlockOptions, loggedInUserDetails?.health_block_id)?.id || '') : ''),
          code: roleFormState.health_block.code || (isLoggedInHierarchyFieldLocked('health_block') ? findMatchedOption(healthBlockOptions, loggedInUserDetails?.health_block_id)?.code || '' : ''),
        },
        sub_division: {
          ...roleFormState.sub_division,
          value: roleFormState.sub_division.value || (isLoggedInHierarchyFieldLocked('sub_division') ? findMatchedOption(subDivisionOptions, loggedInUserDetails?.sub_division_id)?.value || '' : ''),
          id: roleFormState.sub_division.id || (isLoggedInHierarchyFieldLocked('sub_division') ? String(findMatchedOption(subDivisionOptions, loggedInUserDetails?.sub_division_id)?.id || '') : ''),
          code: roleFormState.sub_division.code || (isLoggedInHierarchyFieldLocked('sub_division') ? findMatchedOption(subDivisionOptions, loggedInUserDetails?.sub_division_id)?.code || '' : ''),
        },
        block: {
          ...roleFormState.block,
          value: roleFormState.block.value || (isLoggedInHierarchyFieldLocked('block') ? findMatchedOption(getBlockOptions, loggedInUserDetails?.block_id)?.value || '' : ''),
          id: roleFormState.block.id || (isLoggedInHierarchyFieldLocked('block') ? String(findMatchedOption(getBlockOptions, loggedInUserDetails?.block_id)?.id || '') : ''),
          code: roleFormState.block.code || (isLoggedInHierarchyFieldLocked('block') ? findMatchedOption(getBlockOptions, loggedInUserDetails?.block_id)?.code || '' : ''),
        },
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: '',
          id: '',
        },
      }))
     
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

    useEffect(() => {
      if (!isBlockLevelLogin || formState1.user_type.value !== USER_TYPE.BLOCK_LEVEL) return;

      setRoleFormData((roleDetails: any) => ({
        ...roleDetails,
        block: {
          ...roleDetails.block,
          '#isDisabled': false,
        },
        village: {
          ...roleDetails.village,
          '#isDisabled': true,
          '#required': false,
        },
        gram_panchayat: {
          ...roleDetails.gram_panchayat,
          '#isDisabled': true,
          '#required': false,
        },
      }));
    }, [isBlockLevelLogin, formState1.user_type.value, roleFormData.block?.['#isDisabled'], roleFormData.village?.['#isDisabled']]);

  const getWard=async (ulbId:any)=>{
    try{
    const ward = await getData<any[]>(`${endpoints.getWard(ulbId)}`);
   
    const wardOptions = mapWardOptions(ward.data, roleFormState.ulb.value);
    const loggedInWardMatch = isLoggedInHierarchyFieldLocked('ward')
      ? findMatchedOption(wardOptions, loggedInUserDetails?.ward_id)
      : undefined;
    setRoleFormData((role_details:any) => ({
      ...role_details,
      ward: {
        ...role_details.ward,
        '#options': loggedInWardMatch ? [loggedInWardMatch] : wardOptions,
        '#isDisabled': loggedInWardMatch ? true : role_details.ward['#isDisabled'],
        '#required': (wardOptions.length && role_details.ward['#isDisabled'] === false) ? true : false,
      },
    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      ward: {
        ...roleFormState.ward,
        value: loggedInWardMatch ? loggedInWardMatch.value : (roleFormState.ward.value || ''),
        id: loggedInWardMatch ? String(loggedInWardMatch.id) : (roleFormState.ward.id || ''),
        code: loggedInWardMatch ? loggedInWardMatch.code : (roleFormState.ward.code || ''),
      },
    }))
  }    catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  const getVillage=async (blockId:any)=>{
    try{
      const postData = {
        p_state_id: roleFormState?.state?.id,
        p_dist_id: roleFormState?.district?.id,
        p_sub_dist_ids: roleFormState?.sub_district?.id ? [roleFormState?.sub_district?.id] : [],
        p_block_ids: blockId ? [blockId] : [],
        p_hbsd_ids: [],
      }
    const village = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
    const villageOptions = mapVillageOptions(village.data?.data);
    const loggedInVillageMatch = isLoggedInHierarchyFieldLocked('village')
      ? findMatchedOption(villageOptions, loggedInUserDetails?.village_id)
      : undefined;
    setRoleFormData((role_details:any) => ({
      ...role_details,

      village: {
        ...role_details.village,
        '#options': loggedInVillageMatch ? [loggedInVillageMatch] : villageOptions,
        '#isDisabled': loggedInVillageMatch ? true : role_details.village['#isDisabled'],
        '#required': loggedInVillageMatch ? true : (village.data.meta.numberOfRecords > 0 ? true : false),

      },

    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      village: {
        ...roleFormState.village,
        value: loggedInVillageMatch ? loggedInVillageMatch.value : (roleFormState.village.value || ''),
        id: loggedInVillageMatch ? String(loggedInVillageMatch.id) : (roleFormState.village.id || ''),
        code: loggedInVillageMatch ? loggedInVillageMatch.code : (roleFormState.village.code || ''),
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
      }))
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  const getGramPanchayat=async (blockId:any)=>{
    try{
    const gramPanchayat = await getData<any[]>(`${endpoints.getGramPanchayatByBlockId(blockId)}`);
    const gramPanchayatOptions = mapGramPanchayatOptions(gramPanchayat.data);
    setRoleFormData((role_details:any) => ({
      ...role_details,
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': gramPanchayatOptions,
        '#required': (gramPanchayatOptions.length && roleFormData.gram_panchayat['#isDisabled'] === false) ? true : false,
      },

    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
 }
  }

  const getFacilityType=async ()=>{
    try{
    const facilityType = await getDataWithCache<any[]>(`${endpoints.getFacilityType}`);
    const facilityTypeOptions = mapFacilityTypeOptions(facilityType.data);
    setIntialFacilityTypes({facilityTypeOptions});
    setfacilityFormData((facilityFormData:any) => ({
      ...facilityFormData,
      health_facility_type: {
        ...facilityFormData.health_facility_type,
        '#options': facilityTypeOptions,
      },
      health_provider_tagged: {
        ...fieldFormData.health_provider_tagged,
        '#options': [],
      },
      mobiliser_tagged: {
        ...fieldFormData.mobiliser_tagged,
        '#options': [],
      },
    }));
    setfieldFormData((fieldFormData:any) => ({
      ...fieldFormData,
      health_facility_type: {
        ...fieldFormData.health_facility_type,
        '#options': facilityTypeOptions,
      },
      health_provider_tagged: {
        ...fieldFormData.health_provider_tagged,
        '#options': [],
      },
      mobiliser_tagged: {
        ...fieldFormData.mobiliser_tagged,
        '#options': [],
      },
    }))
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  //Get Facility Types
  useEffect(()=>{
   getFacilityType();
  },[])

  const getFacilityByVillage=async (Id:any)=>{
    try{
    const params ={
      p_village_id:Id,
      p_facilitytype_id:'',
      p_search_facility:''
}
    const facility = await getDataParams<any[]>(`${endpoints.getFacilityByVillage}`,params);
    const facilityOptions = mapFacilityOptions(facility.data);
    applyFacilityNameOptions({ facilityOptions, setInitialFacilityNames, setfacilityFormData, setfieldFormData });
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }

  }

  const isLoggedInUserANM = () => {
    const designationName = loggedInUserDetails?.user_designation_name;
    return designationName === UserDesignation.anm;
  }

  const getfacilitytypename = (facility_type_id: any) => {
    return getFacilityTypeNameById(intialFacilityTypes.facilityTypeOptions, facility_type_id)
  }

  const getFacilityByLoggedInUser=async ()=>{
    try{
    const facility_details_response = await getData<any>(`${endpoints.getLinkedFacilitiesByUserById}/${LoggedInUserId}`);
    const facilityOptions = mapFacilityOptions(
      facility_details_response.data[0],
      (key: any) => ({ facilitytypename: getfacilitytypename(key.facility_type_id) }),
    );
    applyFacilityNameOptions({ facilityOptions, setInitialFacilityNames, setfacilityFormData, setfieldFormData });
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }

  }

  const getFacilityByGramPanchayat=async (Id:any)=>{
    try{
    const params ={
      p_gram_panchayat_id:Id,
      p_facilitytype_id:'',
      p_search_facility:''
}
    const facility = await getDataParams<any[]>(`${endpoints.getFacilityByGramPanchayat}`,params);
    const facilityOptions = mapFacilityOptions(facility.data);
    applyFacilityNameOptions({ facilityOptions, setInitialFacilityNames, setfacilityFormData, setfieldFormData });
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
 }

  }

  const getFacilityByWard=async (Id:any)=>{
    try{
    const params ={
                p_ward_id:Id,
                p_facilitytype_id:'',
                p_search_facility:''
    }
    const facility = await getDataParams<any[]>(`${endpoints.getFacilityByWard}`,params);
    const facilityOptions = mapFacilityOptions(facility.data);
    applyFacilityNameOptions({ facilityOptions, setInitialFacilityNames, setfacilityFormData, setfieldFormData });
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  useHierarchyCascadeEffects({
    roleFormState,
    roleFormData,
    hasZonesCreated,
    userTypeName,
    hasBlocksForDistrict,
    isGrampanchayat,
    loggedInUserDetails,
    getDistrictForZDC,
    getDistrictForState,
    getSubDistBlock,
    getWard,
    getGramPanchayat,
    getVillage,
    setRoleFormState,
    setRoleFormData,
    findMatchedOption,
  });

  useFacilityLocationEffects({
    roleFormState,
    locationTypes: LocationType,
    isLoggedInUserANM,
    getFacilityByLoggedInUser,
    getFacilityByVillage,
    getFacilityByGramPanchayat,
    getFacilityByWard,
    setFacilityLocationId,
    setFacilityLocationType,
  });

  const handleOK=async()=>{
    dispatch(updateForm("isNotVerified",false));
    if(hprNullCheck){
        dispatch(updateForm("isOkButtonClicked",true))
    }
    if(hprNumberCheck){
        dispatch(updateForm("ishprEntered",true));
        dispatch(updateForm("clearHpr",true));
    }
    dispatch(updateForm("hfrAbha", ''));
    setAlertModalOpen(false)
  }

  const verify = {
    hprId: verifyHfr,
    abhaId: verifyAbha
  }

  const contents = [
    <div key="user details">
      <UserPage1 handleFormChange1={handleFormChange1}
      formState1={formState1}
       formData={userData} />
    </div>,
    <div key="Role Details">
      <UserPage2
      handleFormChange2={(value: any, key: string, id: any, option: any, code: any, compositeRoleId:any) => {
        if (key === 'role_name' || key === 'zone_div_circle') {
          const selectedMeta: any = getSelectedOptionsMeta(value, option, key === 'role_name') || { ids: [], codes: [], compositeRoleIds: [] };
          id = selectedMeta.ids;
          code = selectedMeta.codes;
          if(key === 'role_name'){
            compositeRoleId = selectedMeta.compositeRoleIds;
          }
        }

        handleFormChange2(value, key,option, id, code, compositeRoleId);
      }}
      formState2={roleFormState}
      formData={roleFormData}
      onInputChange={handleInputChange}
       />
    </div>,
    <div key="Facility Details">
      <UserPage3
      handleFormChange3={(value: any, key: string, id: any, option: any, code: any) => {
        if (key === 'ward' || key==='village' || key==='gram_panchayat'||key==='health_provider_tagged'||key==="mobiliser_tagged") {
          const selectedMeta: any = getSelectedOptionsMeta(value, option) || { ids: [], codes: [] };
          id = selectedMeta.ids;
          code = selectedMeta.codes;
        }

        handleFormChange3(value, key,id,option, code);
      }}
      hfrVerifyFormData={hfrVerifyFormData}
      formState3={formState1.user_type.value==='Facility Level User'?formStateForFacility:formStateForField}
      verify={verify}
      formData={formState1.user_type.value==='Facility Level User'?facilityFormData:fieldFormData}
      facilityLocationId={facilityLocationId}
      facilityLocationType = {facilityLocationType}
      healthFacilityNames={initialFacilityNames}
      />
    </div>,
  ];
  
  const checkEmailAlreadyExists=async (emailId:string)=>{
    try{
      const payload={
        "emailId":emailId
      }
      const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload));
      const response = await postDataJSON<any>(`${endpoints.checkEmailAlreadyExists}`, {data:encodedPayload});
      const decodedData = JSON.parse(decodeWithKeyAndShift(response?.data?.data));
      return decodedData[0]?.check_email_exists
  }
  catch(error:any){
    return false;
  }
  }

  const checkMobileNumberExists = async (mobileNumber: string) => {
    const data = { userName: mobileNumber };
    const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
    const response = await axios.post(`${endpoints.checkMobileNumberExists}`, { data: encodedPayload }, Auth.loggedInWithJSON);
    const decodedResponse = JSON.parse(decodeWithKeyAndShift(response?.data?.data?.data));
    return decodedResponse?.data?.[0]?.exists_flag === true;
  }

  const handleSave = async (activeIndex: number): Promise<void> => {
    try{
      const errors: boolean[] = [];

      if (activeIndex === 0) {
        const { nextState, isFormError } = await validateBasicDetailsStep({
          formState1,
          isOkButtonClicked,
          hprNullCheck,
          ishprEntered,
          hprNumberCheck,
          isNotVerified,
          userDesignationConstant,
          checkEmailAlreadyExists,
          checkMobileNumberExists,
          onDispatchUpdate: (key: string, value: any) => dispatch(updateForm(key, value)),
          onOpenAlert: () => setAlertModalOpen(true),
        });
        setFormState1(nextState);
        errors[0] = isFormError;
      }

      if (activeIndex === 1) {
        const { nextState, isFormError } = validateRoleHierarchyStep({
          roleFormState,
          roleFormData,
        });
        setRoleFormState(nextState);
        errors[1] = isFormError;
      }

      if (activeIndex === 2) {
        const { nextState, isFormError, isFacilityLevelUser: isFacilityUser } =
          validateFacilityDetailsStep({
            userTypeValue: formState1.user_type.value,
            formStateForFacility,
            formStateForField,
            facilityFormData,
            fieldFormData,
          });

        if (isFacilityUser) {
          setFormStateForFacility(nextState);
        } else {
          setFormStateForField(nextState);
        }
        errors[2] = isFormError;
      }

      setErrors(errors);
}     catch(error:any){
  errorLogger(error?.response?.data||error?.response||error)
}
};

  const finishHandler = async () => {
      let payload:any = buildCreateUserPayload({
        formState1,
        roleFormState,
        formStateForFacility,
        formStateForField,
        ruralUrban,
        isGrampanchayat,
        isVerified,
        hfrAbhaId,
        consentDetails,
        verificationProcessId,
      });

try {
  if (Files) {
    const response = await axios.post(
      `${endpoints.upload}`,
      Files,
      Auth.loggedInWithMultipart()
    );
    const imageToken = response?.data?.data?.imageToken || null;

    payload = {
      ...payload,
      imageToken,
      url: null,
      description: 'Image for user',
    };
  }
  setIsLoading(true)
  const response = await axios.post(`${endpoints.insertUser}`, payload, Auth.loggedInWithJSON());
  if(response.status !== 200)
  {
    throw new Error("Error in Creating User");
  }
  infoLogger(`User has been Created Successfully with the mobile number: ${formState1.mob?.value}, status: ${formState1.user_status?.value}, HPR Id: ${payload?.hprId}, ABHA Id: ${payload?.abhaId}.`,"User Management - Create User");
  dispatch(resetForm());
  navigate(`/user-management`);
  toast.success("Records have been successfully created", {
  position: "top-center"
  }); 
}catch(error:any) {
  const errorMessage=error?.response?.data?.messages?.[0]?.stackTraces ||
    error?.response?.data?.messages?.[0]?.messageDetails||
    error?.response?.data?.messages||
    error?.response?.data||
    error?.response||
    error?.message||
    error;
  toast.error(
    `Error while inserting the User: ${errorMessage}`, {
    position: "top-right"
    });
    errorLogger(`Error while inserting the User  ${formState1.mob?.value} of type ${formState1.user_type?.value}: ${errorMessage}`);
} finally {
  setIsLoading(false)
}
 

  };

  useEffect(() => {
    setIsFormValidated(false);
  }, [activeIndex]);

  useEffect(() => {
    if (!errors[activeIndex] && isFormValidated) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = true;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex + 1) * navs;
      setSelectedPerc(perc);
    }
    if (errors[activeIndex] && formCompleted[activeIndex]) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      setFormCompleted(newFormCompleted);
    }
  }, [errors]);

  const breadcrumbItemName=[
    { value: page, label: 'User Management' },
    { value: page, label: 'Create User' },
  ];

  const onHandleBackArrowButton=()=>{
    navigate(`/user-management`);
    dispatch(resetForm());
  };

  const handleNavClick = (index: number): void => {
    if (formCompleted[index]) {
      setActiveIndex(index);
    }
  };

  const handlePrevious = (): void => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      newFormCompleted[activeIndex - 1] = false;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex - 1) * navs;
      setSelectedPerc(perc);
    }
  };

  const handleSubmit = (): void => {
    handleSave(activeIndex);
    setIsFormValidated(true);
  };

  const handleNext = (): void => {
    if (activeIndex < navItemsModal.length - 1) {
      setActiveIndex(activeIndex + 1);
    } else if (activeIndex === navItemsModal.length - 1) {
      setSelectedPerc(selectPerc + navs);
    }
  };

  const CloseFacility=()=>{
    setCloseModal(true);
  }

  const closeCreateModal=(value:boolean)=>{
    if(value){
      setCloseModal(false);
      dispatch(resetForm());
      navigate(`/user-management`);
    }
    else{
      setCloseModal(false);
    }
  }

  return (
    <>
    <Loading isLoading={isLoading} />
     

          <CreateCommonComponent 
            breadcrumbItemName={breadcrumbItemName} 
            onHandleBackArrowButton={onHandleBackArrowButton}
            navItemsModal={navItemsModal}
            activeIndex={activeIndex}
            handleNavClick={handleNavClick}
            formCompleted={formCompleted}
            headerName={"Create a new user"}
            progressBarPerc={selectPerc}
            contents={contents}
            handlePrevious={handlePrevious}
            handleSubmit={handleSubmit}
            finishHandler={finishHandler}
            handleNext={handleNext}
            handleCancel={CloseFacility}
            closeCreateModal={closeCreateModal}
            closeModal={closeModal}
          />
      <CommonModal
      show={alertModalOpen}
      handleClose={()=>{}}
      conditionalClass="modal_component dynamic_form_field"
      showCustomHeader={true}
      title=""
      size="md"
      footer={
        <>
          <ButtonModal
            onClick={handleOK}
            id="cancel"
            buttonName={'OK'}
            colorType={'secondary'}
          />
        </>
      }
    >
      <div className='hrp-warning-modal'>
        <div className='icon-class'><RedInfoIcon /></div>
        <div className='warning-text'>
          Please note that you are proceeding without verifying {(formState1.user_type.value === 'Field Level User' || (formState1.user_type.value === 'Facility Level User' && formState1.designation?.value === 'MPW/MPHW')) ? 'ABHA ID' : 'HPR ID'}. In that case, saved user will be inactive and {(formState1.user_type.value === 'Field Level User' || (formState1.user_type.value === 'Facility Level User' && formState1.designation?.value === 'MPW/MPHW')) ? 'ABHA ID' : 'HPR ID'} would not be saved.
        </div>
      </div>
    </CommonModal>
    </>
  );

};

export default CreateNewUser;
